import { CountryCode } from 'libphonenumber-js'
import { AddressCountries } from '@src/types'

export const getCountryCodeByCountry = (country: AddressCountries): CountryCode => {
  return country as CountryCode
}
